import { Type } from 'class-transformer';
import { IsString, IsOptional, MaxLength, MinLength, IsNumber, IsHexColor } from 'class-validator';
import { CompanyDto } from '../../main';

export class CreateTagDto {
  @IsString()
  @MinLength(1)
  @MaxLength(30)
  name: string;

  @IsOptional()
  @IsHexColor()
  color: string;
}

export class TagDto extends CreateTagDto {
  id: number;
  tagLinks: TagLinkDto[];
}
export class UpdateTagDto extends CreateTagDto {
  id: number;
}

export class CreateTagLinkDto {
  @IsNumber()
  tagId: number;

  @IsOptional()
  @IsNumber()
  companyId: number;
}

export class TagLinkDto extends CreateTagDto {
  id: number;

  @Type(() => CompanyDto)
  company: CompanyDto;
}
